import styles from './IconFeatureGridCard.module.scss';

import type { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { Grid } from 'components/Grid/Grid';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import { TextV2 } from 'components/TextV2/TextV2';
import { toEntry, AppType, WithCMS } from 'services/cms/typesUtil';
import { AnimatedIcon } from '../AnimatedIcon/AnimatedIcon';
import { ICON_FEATURE_GRID_CARD_TEST_ID } from './IconFeatureGridCard.const';

type IconFeatureGridProps = AppType.Component<{
  item: WithCMS<AppType.Content>;
}>;

export const IconFeatureGridCard: React.FC<IconFeatureGridProps> = ({ item }) => {
  if (!item) return null;
  const animationRef = React.createRef<Player>();

  const toggleAnimation = (play: boolean) => {
    if (play) {
      animationRef.current?.play();
    } else {
      animationRef.current?.stop();
    }
  };

  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={3}
      onMouseEnter={() => toggleAnimation(true)}
      onMouseLeave={() => toggleAnimation(false)}
      className={styles.iconFeatureGridItemList}
      key={item.id}
    >
      <div data-testid={ICON_FEATURE_GRID_CARD_TEST_ID.gridCell} className={styles.iconFeatureGridItem}>
        <ContentLinkV2 entry={toEntry(item.link)} hideTitle>
          <AnimatedIcon autoplay={false} src={item.image.file?.url} ref={animationRef} />
          <TextV2
            hasId
            value={item?.title}
            tagName="h5"
            variant="h5-bold"
            className={styles.iconFeatureGridItemHeading}
          />
          <TextV2
            value={item?.blurb}
            tagName="div"
            variant="body"
            className={styles.iconFeatureGridItemBlurb}
          />
          <RichBlurb document={item?.richBlurb} className={styles.iconFeatureGridItemBlurb} />
        </ContentLinkV2>
      </div>
    </Grid>
  );
};
